import { createSelector } from 'reselect';

import { selectFactory, transformListToObject } from '../helpers';

import { STORE_FIELDS, STORE_NAME, VALUE_FIELDS } from './constants';

const selectCarInstance = (state) => {
  return state[STORE_NAME];
};

export const selectField = selectFactory({ selector: selectCarInstance });

export const selectDisabled = createSelector(selectField(STORE_FIELDS.DISABLE_FIELDS), (list) => {
  return transformListToObject({ list, value: true });
});
export const selectNestedDisabled = selectFactory({ fallback: false, selector: selectDisabled });

export const selectError = selectField(STORE_FIELDS.ERROR);

export const selectErrors = selectField(STORE_FIELDS.ERRORS);
export const selectNestedErrors = selectFactory({ fallback: '', selector: selectErrors });

export const selectFetch = selectField(STORE_FIELDS.FETCH);

export const selectHidden = createSelector(selectField(STORE_FIELDS.HIDDEN_FIELDS), (list) => {
  return transformListToObject({ list, value: true });
});
export const selectNestedHidden = selectFactory({ fallback: false, selector: selectHidden });

export const selectValues = selectField(STORE_FIELDS.CAR_INSTANCE);
export const selectValuesField = selectFactory({ selector: selectValues });
export const selectNestedValues = selectFactory({ fallback: undefined, selector: selectValues });

export const hasDiscount = createSelector(selectValues, (state) => {
  const instance = state || {};
  const price = Number(instance[VALUE_FIELDS.PRICE] || 0);
  const offerPrice = Number(instance[VALUE_FIELDS.OFFER_PRICE] || 0);

  return price > 0 && offerPrice > 0 && price > offerPrice;
});
